import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import {
  OnboardingProgressDiv,
  isCameraCheckSupported,
} from "../Onboarding/OnboardingProgressDiv";
import { WireGuardSetupScreen } from "./WireGuardSetupScreen";

type WireGuardDecisionOption = "yes" | "no" | null;

export const WireGuardDecisionScreen = ({
  setVisibleScreen,
}: {
  setVisibleScreen: any;
}) => {
  const [selectedOption, setSelectedOption] =
    React.useState<WireGuardDecisionOption>(null);

  const goToOnboardingProgress = () =>
    setVisibleScreen(
      <OnboardingProgressDiv
        percentage={
          isCameraCheckSupported()
            ? localStorage.healthMonitoringOnly === "true"
              ? 33
              : 25
            : 33
        }
        step={1}
        setVisibleScreen={setVisibleScreen}
      />
    );

  const handleNext = () => {
    if (selectedOption === "yes") {
      setVisibleScreen(<WireGuardSetupScreen setVisibleScreen={setVisibleScreen} />);
      return;
    }

    goToOnboardingProgress();
  };

  return (
    <div className="pt-[140px] pl-[30px]">
      <p className="font-mulish mb-6 text-[20px] font-bold text-[#283E6D]">
        Would you like to onboard a new wireguard tunnel for this site?
      </p>
      <div className="mb-8 flex flex-col gap-2">
        <FormControlLabel
          sx={{ fontFamily: "Mulish", color: "#001943" }}
          label="Yes"
          control={
            <Checkbox
              checked={selectedOption === "yes"}
              onChange={() => setSelectedOption("yes")}
            />
          }
        />
        <FormControlLabel
          sx={{ fontFamily: "Mulish", color: "#001943" }}
          label="No"
          control={
            <Checkbox
              checked={selectedOption === "no"}
              onChange={() => setSelectedOption("no")}
            />
          }
        />
      </div>
      <OrangeTextButton
        onClick={handleNext}
        text="Next"
        disabled={selectedOption === null}
      />
    </div>
  );
};
